import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/pending/ConfirmationOfVesselCompletionAndDelivery'
const ConfirmationOfVesselCompletionAndDelivery = () => {
  return (
    <Layout
      title={'Confirmation of Vessel Completion and Delivery'}
    >
      <Component />

    </Layout>
  )
}

export default ConfirmationOfVesselCompletionAndDelivery